import { cn } from '@/lib/utils'

interface PigmentTickProps {
  className?: string
  /** Accessible name when the tick carries meaning on its own (the saved tick); decorative otherwise. */
  label?: string
}

/**
 * The signature element: the red arrow tip cut from the cathedral mark, 0.6 em wide, drawn in
 * over 350 ms on mount (motion.css `pigment-tick`, static under reduced motion). The
 * `<symbol id="pigment-tick">` lives in index.html so the splash draws the same shape before
 * any bundle loads. Place it before a page title, a section title on Beranda, or beside
 * "Tersimpan", inside a flex row with `items-baseline` so it sits on the first line of a
 * wrapped title; never as a bullet, never rotated, never recoloured.
 */
export function PigmentTick({ className, label }: PigmentTickProps) {
  if (label === undefined) {
    return (
      <svg
        className={cn('pigment-tick', className)}
        aria-hidden="true"
        focusable="false"
        data-signature="pigment-tick"
      >
        <use href="#pigment-tick" />
      </svg>
    )
  }
  return (
    <svg
      className={cn('pigment-tick', className)}
      role="img"
      focusable="false"
      data-signature="pigment-tick"
    >
      <title>{label}</title>
      <use href="#pigment-tick" />
    </svg>
  )
}
